KXL.module('GamesApp.Story', function (Story, KXL, Backbone, Marionette, $, _) {
	Story.View = Marionette.ItemView.extend({
		template: '#game-story-template'
	});
});
